module.exports = __webpack_public_path__ + "48ccdc3a772d197fd37fa177d730e9e9.svg";